import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElBanner = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  ${isMobile} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  align-items: center;
  /* justify-content: center; */
  ${isMobile} {
    align-items: center;
    justify-content: center;
    flex-direction: column;
    * {
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }
`;

export const ElTitle = styled.p`
  /* width: 100%; */
  text-align: left;
  font-family: sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.6em;
  color: var(--theme-main-flat-dark-color);
  b {
    font-size: 17px;
    font-weight: 600;
  }
`;

export const ElpoweredImage = styled.img`
  width: 100%;
`;

export const elGapBanner = css`
  gap: 20px;
`;

export const elGapTitle = css`
  gap: 10px;
`;
